import React from 'react';

import Edit from '@mui/icons-material/Edit';
import { Button, Tooltip } from '@mui/material';

export default function EditBorderButton({
  clickAction,
  sx,
  disabled = false,
  tooltipText = '',
  text = null,
  variant = 'outlined',
  extraBtnProps = {},
}) {
  return (
    <Tooltip title={tooltipText} placement="top">
      <span>
        <Button
          disabled={disabled}
          variant={variant}
          sx={{ ...sx }}
          onClick={clickAction}
          startIcon={text ? <Edit /> : null}
          {...extraBtnProps}
        >
          {text ? text : <Edit />}
        </Button>
      </span>
    </Tooltip>
  );
}
